module.exports = __webpack_public_path__ + "dist/logo_light_444_120.63d23ef2.png";